import WizardModalWrapperLayout from 'Views/Page/Content/Modal/Layouts/WizardModalWrapperLayout';
import React from 'react';
import Content
  from 'Views/Page/Content/Templates/WizardTemplates/PlannerAccountOpeningRiskToleranceContent/PlannerAccountOpeningRiskToleranceContent';

const Layout = () => (
  <WizardModalWrapperLayout>
    <Content />
  </WizardModalWrapperLayout>
);

export default Layout;
